import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../core/services/dataBean/useDataBean';
import { _UBLItemInvoice } from '../../../../../../core/services/dataBean/EntityCatalog';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    disable?: boolean;
}

export const GoodTypesConstantsEditor = ({ idSelector, onChange, label, disable }: Props) => {

    const goodTypes = useDataBean(_UBLItemInvoice)
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(null);

    useEffect(() => {
        if (idSelector) {
            setID(idSelector);
        }
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(e);
    }

    const getLista = () => {
        goodTypes.instance.getGoodTypesConstants(null).then(
            (resp) => {
                setLista(resp);
            }
        );
    }


    return (
        <>
            <label>{label ?? "Tipo de Ausentismo"}</label>
            <select disabled={disable} className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null} >...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                        )
                    })
                }
            </select>
        </>
    )
}